import { useContext } from "react";
import { UserContext } from "../context/User.context";
/** Garder synchrone avec `SUPER_ADMIN_EMAILS` dans `oseo-server/api/institution/institution_abacus_acl.js`. */
export const whiteListeSuperAdmin = [
  "admin@oseo.ch",
  "fmorciano@oseo-vs.ch",
  "michael@thecomputerfirm.com",
  "dpiressimoes@oseo-vs.ch",
  "jsavioz@oseo-vs.ch",
];

export const isSuperAdmin = () => {
  const { user } = useContext(UserContext);

  if (
    whiteListeSuperAdmin.includes(user.email) ||
    user.subRoles.includes("superAdmin")
  ) {
    return true;
  } else {
    return false;
  }
};
